import {
  ProcessStep,
  MaterialLayout,
  ExtendedPart,
  ProductLine,
  QuoteRequest,
  QuoteRequestLine,
} from "../types";
import { OptimizedMachineTimes } from "./computeOptimizedMachineTimes";
import { computeQuoteRequestLineTransport } from "./computeQuoteRequestLineTransport";

export type ComputeQuoteRequestTransportParams = {
  quoteRequest: QuoteRequest & {
    quoteRequestLines: (QuoteRequestLine & {
      processSteps: (ProcessStep & {
        materialLayout: MaterialLayout | null;
        productLines: ProductLine[];
      })[];
      part: ExtendedPart;
    })[];
  };
  optimizedMachineTimes: OptimizedMachineTimes;
};

export const computeQuoteRequestTransport = ({
  quoteRequest,
  optimizedMachineTimes,
}: ComputeQuoteRequestTransportParams) => {
  const { quoteRequestLines } = quoteRequest;

  let transportProcessesCost = 0;
  let transportProcessesMargin = 0;
  let transportProcessesPrice = 0;

  quoteRequestLines.forEach((quoteRequestLine) => {
    const {
      transportProcessesCost: quoteRequestLineTransportProcessesCost,
      transportProcessesMargin: quoteRequestLineTransportProcessesMargin,
      transportProcessesPrice: quoteRequestLineTransportProcessesPrice,
    } = computeQuoteRequestLineTransport(quoteRequestLine, optimizedMachineTimes);

    transportProcessesCost += quoteRequestLineTransportProcessesCost;
    transportProcessesMargin += quoteRequestLineTransportProcessesMargin;
    transportProcessesPrice += quoteRequestLineTransportProcessesPrice;
  });

  return {
    transportProcessesCost,
    transportProcessesMargin,
    transportProcessesPrice,
  };
};
